import { createSlice } from '@reduxjs/toolkit';
import api from 'src/api/index';
import i18n from 'src/i18n';
import { showErrorToast, showSuccessToast } from './toast';

const initialState = {
	authUser: null,
	isLoading: true
};

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setAuthUser: (state, action) => {
			state.authUser = action.payload;
		},
		setIsAuthLoading: (state, action) => {
			state.isLoading = action.payload;
		}
	},
});

export const { setAuthUser, setIsAuthLoading } = authSlice.actions;

export const getAuthUser = ({ silent = false } = {}) => async (dispatch) => {

	try {

		if (!silent) {
			dispatch(setIsAuthLoading(true));
		}

		const user = await api.getUser();

		if (user) {
			dispatch(setAuthUser(user));
		}

	} catch (error) {

		// Если пользователь не авторизован (401) — это нормально, просто сбрасываем стейт
		dispatch(setAuthUser(null));

	} finally {

		if (!silent) {
			dispatch(setIsAuthLoading(false));
		}

	}
};

export const updateUserData = (userData) => async (dispatch) => {

	try {

		const userId = await api.updateUserData(userData);

		await dispatch(getAuthUser());

		if ( userId ) {

			dispatch(showSuccessToast({
				title: i18n.t('toasts.successFull'),
				description: i18n.t('toasts.userDataUpdated')
			}));

		}

	} catch(error) {

		dispatch(showErrorToast({
			description: i18n.t('toasts.failedUpdateUser')
		}));
		
		throw error;

	}

};

export default authSlice.reducer;
